import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useTransition, animated } from 'react-spring';
const Container = styled.div `
  position: relative;
  height: 100%;
  width: 100%;
`;
const transitionStyles = (transitionType) => {
    switch (transitionType) {
        case 'slideInLeft':
            return {
                from: { opacity: 0, transform: 'translateX(-40%)', height: 'inherit', width: 'inherit' },
                enter: { opacity: 1, transform: 'translateX(0%)' },
            };
        case 'slideInRight':
            return {
                from: { opacity: 0, transform: 'translateX(40%)', height: 'inherit', width: 'inherit' },
                enter: { opacity: 1, transform: 'translateX(0%)' },
            };
    }
    console.warn(`transition type: ${transitionType} is not a valid transition option`);
    return;
};
export const Transition = ({ children, delay = 800, initiateTransition, transitionType, }) => {
    // delay should be at least 800 ms so that it can render between states without throwing an error
    const [showTransition, setShowTransition] = useState(false);
    useEffect(() => {
        if (initiateTransition) {
            setTimeout(() => {
                handleInitiateAnimation();
            }, delay);
        }
    }, [initiateTransition]);
    const handleInitiateAnimation = useCallback(() => setShowTransition(true), []);
    if (!initiateTransition) {
        return null;
    }
    const transition = transitionStyles(transitionType);
    if (!transition) {
        return null;
    }
    const transitions = useTransition(showTransition, null, transition);
    return (React.createElement(Container, null, transitions.map(({ item, props, key }) => {
        if (item) {
            return (React.createElement(animated.div, { style: props, key: key }, children));
        }
        else {
            return null;
        }
    })));
};
